import { exportFileTypes } from '../../../../../models/exportFileTypes';

export interface TransactionsListReportFormModel {
  from: string | null;
  to: string | null;
  system_posting: boolean;
  cash_register_ids: number[] | null;
  cashier_ids: number[] | null;
  operation_id: number | null;
  charge_group_ids: number[] | null;
  billing_group_ids: number[] | null;
  charge_code_ids: number[] | null;
  type: TransactionListTypeNum;
  billing: TransactionListBillingNum;
  order_by: TransactionListOrderByNum;
  file_type: exportFileTypes;
}

export enum TransactionListTypeNum {
  ALL = 'all',
  PAYMENT = 'payment',
  CHARGE = 'charge',
}

export enum TransactionListBillingNum {
  All = 'all',
  ACCOUNT = 'account',
  ROOM = 'room',
}

export enum TransactionListOrderByNum {
  DATE = 'date',
  AMOUNT = 'amount',
}
